module.exports = __webpack_public_path__ + "static/media/btn-reset.cb80d4ce.svg";